import React from 'react';
import './FicheGroepsAankoop.scss';
import { MoreInfo } from '../../MoreInfo/MoreInfo';
import { Image } from '../../../Image/Image';
import { FicheType } from '../../FicheType/FicheType';

export const FicheGroepsaankoop = (props) => {
    return (
        <div
            className={`c-fiche c-groepsaankopen-full ${props.data?.hasDetail ? "u-has-detail" : ""}`}
            onClick={() => {
                if (props.data?.hasDetail && props.openPopup) {
                    props.openPopup(props.data.urlSegment);
                }
            }}
            data-aos="fade-up"
        >
            <div>
                <FicheType type={props.data.type} style={{ backgroundColor: (props.data.typeColor != null ? "#" + props.data.typeColor : "unset") }} />
                {props.data?.tagIcon?.url &&
                    <div className="c-tag-list">
                        <div className="c-tag themeicon" title={props.data.tagIcon.alt}>
                            <Image alt={props.data.tagIcon.alt} src={props.data.tagIcon.url} />
                        </div>
                    </div>
                }
                <div className="image" title="Meer over">
                    {props.data?.image?.url &&
                        <Image alt={props.data.title} src={(props.data.image && props.data.image.url)} />
                    }
                </div>
                <header className="c-fiche__header">
                    <h2 className="title" title={props.title} dangerouslySetInnerHTML={{ __html: props.data.title }}></h2>
                    {props.data.text}
                </header>
                <MoreInfo
                    data={props.data}
                    openPopup={props.openPopup}
                    cta={props.dictionary.moreInfo} />
            </div>
        </div>
    );
}